import repository from '@/services/repository';

const resource = '/actionPoints';

export default {
    lookup(options: any, projectId: string) {
        const formData = new FormData();

        for ( const key in options ) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        if (!projectId) {
            projectId = '';
        }

        return repository.post(`${resource}/lookup?projectId=${projectId}`, formData, {
            headers: {'Content-Type': 'multipart/form-data' },
        });
    },
    getSingle(id: string) {
        return repository.get<IActionPointExtended>(`${resource}/${id}`);
    },
    create(payload: IActionPointCreateDto) {
        return repository.post(`${resource}`, payload);
    },
    update(payload: IActionPointUpdateDto) {
        return repository.put(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return repository.delete(`${resource}/${id}`);
    },
    uploadFile(id: string, file: Blob, filename: string) {
        const formDataToUpload = new FormData();
        formDataToUpload.append('image', file, filename);
        return repository.post<string>(`${resource}/${id}/Upload`, formDataToUpload, {
            headers: {'Content-Type': 'multipart/form-data' },
        });
    },
    mail(id: string, mail: IActionPointMailDto) {
        return repository.post(`${resource}/${id}/Mail`, mail);
    },
    changeStatus(id: string, status: number) {
        const data: IActionPointStatusChangeCommand = {
            id,
            status,
        };

        return repository.post(`${resource}/${id}/status`, data);
    },
    getCountOfMyActionPoints() {
        return repository.get<number>(`${resource}/count`);
    }
};
